import { ShieldAlert } from "lucide-react";

export function AuthorManuscriptNotice({ className = "", testId = "author-manuscript-notice" }) {
  return (
    <div
      className={`rounded-xl border border-[hsl(var(--sb-gold))]/50 bg-[hsl(var(--sb-gold))]/10 p-4 text-sm leading-relaxed text-foreground ${className}`}
      role="note"
      data-testid={testId}
    >
      <div className="flex items-center gap-2 font-semibold">
        <ShieldAlert size={16} className="shrink-0 text-[hsl(var(--sb-gold-2))]" />
        Before you share your manuscript
      </div>
      <p className="mt-2">
        Last Bookmark requires readers to respect manuscript confidentiality and prohibits AI-generated
        beta reading feedback and sharing manuscript content with AI tools or services. However, we cannot
        monitor every reader&rsquo;s activity outside the platform or guarantee that a reader will comply
        with these rules.
      </p>
      <p className="mt-2">
        Before sharing your work, use Coffee Chats and messaging to discuss the reader&rsquo;s experience,
        feedback process, and how they will handle your manuscript. Share only when you feel comfortable
        proceeding.
      </p>
      <p className="mt-2">
        If you suspect misuse, contact{" "}
        <a href="mailto:hello@lastbookmark.com" className="link-underline font-medium break-all">hello@lastbookmark.com</a>.
        We take reports seriously, review the available information, and may suspend or remove users found
        to have violated our rules.
      </p>
    </div>
  );
}
